webpackJsonp([114276838955818,60335399758886],{

/***/ 121:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"みんなの学際バー（仮）","lastUpdate":"2017/12/7"}}},"layoutContext":{}}

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(253);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(121);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhCh0GEBMz/tpZAAABNElEQVQ4y7WUsU4CQRCG/4OQGMRggyQYQmNxodQXOGJhIeEdrIhPgLwAodFG26vo6CRa+gBKRUNl4iUUWqkkYAgGPosTOfDwThOnnP2+ye7O7Er/HYZfkqL2Jd0YVyEqUKTNLNoUw8NBki+8SvoRXpYohIDnUkF0QuMAHZGmERpvkHa3ZdENhLtY3mPHqDJcCQ+pEpM4YdvF1zkjRY6WL94ixxY2KR4wXcEEnikToYSzADuUiHDMC2DieAWAW3aJU2cMwJg6cfa4+1z1EWDCOUnyVKiQJ8kFk681XwHgkTIZMpR5Wsh7hAT9wGvtk8DBjEiSMZAdOPe23rSmjVkfotSYrqw+pUaUI+DS2zyLJqNv8Iim22MOGHC69ETZ1KF2lFVWUk893evaeJ3Pg/H+qw/gT/EBM/FuXYwRWPsAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTctMTAtMjlUMDY6MTY6MTkrMDE6MDD+e5aiAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE3LTEwLTI5VDA2OjE2OjE5KzAxOjAwjyYuHgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ted.3671f986.jpg";

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.5031e140.ico";

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _layoutModule = __webpack_require__(344);
	
	var _layoutModule2 = _interopRequireDefault(_layoutModule);
	
	var _logo_white = __webpack_require__(617);
	
	var _logo_white2 = _interopRequireDefault(_logo_white);
	
	var _favicon = __webpack_require__(357);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ted = __webpack_require__(156);
	
	var _ted2 = _interopRequireDefault(_ted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListLink = function ListLink(props) {
	  return _react2.default.createElement(
	    "li",
	    { style: { display: "inline-block", marginRight: "1rem", height: "1rem" } },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.to, activeClassName: _layoutModule2.default.activeHeaderLink },
	      props.children
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { charSet: "utf-8" }),
	      _react2.default.createElement("meta", { httpEquiv: "x-ua-compatible", content: "ie=edge" }),
	      _react2.default.createElement("meta", {
	        name: "viewport",
	        content: "width=device-width, initial-scale=1, shrink-to-fit=no"
	      }),
	      _react2.default.createElement("link", { rel: "shortcut icon", href: _favicon2.default, type: "image/x-icon" }),
	      _react2.default.createElement("meta", { name: "description", content: "\u5317\u6D77\u9053 \u672D\u5E4C\u306E\u30AB\u30B8\u30E5\u30A2\u30EB\u306A\u30D0\u30FC\u3067\u304A\u9152\u3092\u306E\u307F\u3001\u79D1\u5B66\u3001\u54F2\u5B66\u3001\u7269\u7406\u5B66\u3001\u751F\u7269\u5B66\u3001\u5730\u653F\u5B66\u3001\u82B8\u8853\u3001\u306A\u3069\u3001\u5B66\u554F\u306E\u5206\u91CE\u3092\u8D85\u3048\u3066\u7814\u7A76\u767A\u8868\u3001\u30C8\u30FC\u30AF\u30A4\u30D9\u30F3\u30C8\u3001\u30BB\u30DF\u30CA\u30FC\u3001\u8A0E\u8AD6\u4F1A\u3001\u52C9\u5F37\u4F1A\u306A\u3069\u3092\u884C\u3046\u30A2\u30AB\u30C7\u30DF\u30C3\u30AF\u306A\u30E9\u30A6\u30F3\u30B8\u7684\u30A4\u30D9\u30F3\u30C8\u3067\u3059\u3002" }),
	      _react2.default.createElement("meta", { name: "keywords", content: "\u5317\u6D77\u9053,\u672D\u5E4C,\u30D0\u30FC,\u304A\u9152,\u30E9\u30A6\u30F3\u30B8,\u5B66\u554F,\u79D1\u5B66,\u54F2\u5B66,\u7269\u7406\u5B66,\u751F\u7269\u5B66,\u5730\u653F\u5B66,\u793E\u4F1A\u5B66,\u82B8\u8853,\u30C8\u30EA\u30D3\u30A2,\u77E5\u8B58,\u52C9\u5F37,\u96D1\u5B66,\u7814\u7A76,\u767A\u8868,\u30C8\u30FC\u30AF,\u30A4\u30D9\u30F3\u30C8,\u30BB\u30DF\u30CA\u30FC,\u7D4C\u6E08,\u610F\u8B58\u9AD8\u3044,\u30CE\u30DE\u30C9,\u7D4C\u55B6,\u6559\u80B2,\u91D1\u878D,\u30A2\u30AB\u30C7\u30DF\u30C3\u30AF,\u30E9\u30A6\u30F3\u30B8,\u5C45\u9152\u5C4B,\u30E9\u30A4\u30D6" }),
	      _react2.default.createElement("meta", { property: "og:site_name", content: data.site.siteMetadata.title }),
	      _react2.default.createElement("meta", { property: "og:title", content: data.site.siteMetadata.title }),
	      _react2.default.createElement("meta", { property: "og:type", content: "website" }),
	      _react2.default.createElement("meta", { property: "og:url", content: "http://www.mingaku-sapporo.netlify.com" }),
	      _react2.default.createElement("meta", { property: "og:image", content: _ted2.default }),
	      _react2.default.createElement("meta", { property: "og:description", content: "\u672D\u5E4C\u306E\u30AB\u30B8\u30E5\u30A2\u30EB\u306A\u30D0\u30FC\u3092\u4F1A\u5834\u3068\u3057\u3066\u98F2\u98DF\u3092\u697D\u3057\u307F\u3064\u3064\u3001\u6BCE\u56DE\u3072\u3068\u3064\u306E\u30C6\u30FC\u30DE\u3092\u6C7A\u3081\u3001\u7814\u7A76\u767A\u8868(\u30C8\u30FC\u30AF\u30A4\u30D9\u30F3\u30C8)\u3084\u3001\u52C9\u5F37\u4F1A\u306A\u3069\u3092\u884C\u3046\u4F1A\u3067\u3059\u3002" }),
	      _react2.default.createElement("meta", { property: "fb:app_id", content: "297372647428124" }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	      _react2.default.createElement("meta", { name: "twitter:site", content: "@karuhiko1" })
	    ),
	    _react2.default.createElement(
	      "header",
	      { className: _layoutModule2.default.header },
	      _react2.default.createElement(
	        "div",
	        { style: { display: "inline-block", float: "left" } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/", style: { textShadow: "none", backgroundImage: "none" } },
	          _react2.default.createElement("img", { src: _logo_white2.default, style: { width: "24px", float: "left", margin: "0 1rem" } }),
	          _react2.default.createElement(
	            "h4",
	            { style: { display: "inline", color: "white", float: "left", margin: ".3rem" } },
	            data.site.siteMetadata.title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { display: "inline-block", float: "left", height: "40px" } },
	        _react2.default.createElement(
	          "ul",
	          { style: { listStyle: "none", marginBottom: 0 } },
	          _react2.default.createElement(
	            ListLink,
	            { to: "/about/", style: { padding: 0 } },
	            "About"
	          ),
	          _react2.default.createElement(
	            ListLink,
	            { to: "/archives/", style: { padding: 0 } },
	            "Archives"
	          ),
	          _react2.default.createElement(
	            ListLink,
	            { to: "/contact/", style: { padding: 0 } },
	            "Contact"
	          )
	        )
	      ),
	      _react2.default.createElement("div", { style: { clear: "both" } })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _layoutModule2.default.contentsHolder },
	      children()
	    ),
	    _react2.default.createElement(
	      "footer",
	      { className: _layoutModule2.default.footer },
	      _react2.default.createElement(
	        "p",
	        null,
	        "Last update ",
	        data.site.siteMetadata.lastUpdate
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contentsHolder":"src-styles----layout-module---contentsHolder---OFX5S","header":"src-styles----layout-module---header---3KFj2","activeHeaderLink":"src-styles----layout-module---activeHeaderLink---3DpX_","logo":"src-styles----layout-module---logo---3tWHQ","footer":"src-styles----layout-module---footer---1tUy7"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-cc1f94dca4940aec51d2.js